import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { Helmet } from "react-helmet";

class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      refresh: false,
    };
  }
  checkRecent = () => {
    console.log("error checkRecent");
    this.setState({ refresh: true });
  };

  render() {
    const { refresh } = this.state;

    if (refresh) {
      this.setState({ refresh: false });
      return <Redirect to={`/`} />;
    }

    return (
      <div className="home-page-component">
        <Helmet>
          <title>Mobile Apps | Dream Chimney</title>
        </Helmet>
        <div className="home-component">
          <div className="page-header">
            <h1>Mobile Apps</h1>
          </div>

          <div>
            <div className="row">
              <div className="col-xs-12 col-sm-6">
                <div className="well">
                  <h3>Dream Chimney App</h3>
                  <h4>Available free in the App store</h4>
                  <p></p>
                  <div>
                    <div>
                      <a href="https://apps.apple.com/us/app/dreamchimney/id1610876622?itsct=apps_box_badge&amp;itscg=30200">
                        <img
                          src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1663891200&h=ab67a289157a4b7b40b0f7cb06b53ef7"
                          alt="Download on the App Store"
                          className="img-responsive center-block"
                        />
                      </a>
                    </div>
                    <div>
                      <img
                        src="https://www.dreamchimney.com/img/iPhoneDCApp.jpg"
                        alt="Dream Chimney app iphone"
                        className="img-responsive center-block iphone"
                      />
                    </div>
                    <div className="qr-codes">
                      <img
                        src="https://www.dreamchimney.com/img/DCApp-qr-code-icon.jpg"
                        alt="Dream Chimney app iphone QR code"
                        className="img-responsive center-block"
                      />
                      <p>Scan this QR Code to view in App Store</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-sm-6">
                <div className="well">
                  <h3>Mix of the Week App</h3>

                  <h4>Available free in the App store</h4>
                  <p></p>

                  <div>
                    <a target="_blank" href="https://itunes.apple.com/us/app/mix-of-the-week/id1412587696?mt=8&at=10lsNn">
                      <img
                        src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1663891200&h=ab67a289157a4b7b40b0f7cb06b53ef7"
                        alt="Download on the App Store"
                        className="img-responsive center-block"
                      />
                    </a>
                  </div>

                  <a target="_blank" href="https://itunes.apple.com/us/app/mix-of-the-week/id1412587696?mt=8&at=10lsNn">
                    <img
                      src="//www.dreamchimney.com/mainpage/motw-phone-screenshot.png"
                      alt="Mix of the Week app iphone QR code"
                      className="img-responsive center-block iphone"
                    />
                  </a>

                  <p></p>
                  <div className="qr-codes">
                    <img src="https://www.dreamchimney.com/img/MOTWApp-qr-code-icon.jpg" />
                    <p>Scan this QR Code to view in App Store</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default HomePage;
